

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const getStatusColor = (status: string): string => {
    const normalized = status.toLowerCase();

    if (normalized === 'running' || normalized === 'healthy' || normalized === 'active') {
      return 'bg-green-500/20 text-green-400 border-green-500/30';
    }
    if (normalized === 'exited' || normalized === 'stopped' || normalized === 'down') {
      return 'bg-red-500/20 text-red-400 border-red-500/30';
    }
    if (normalized === 'paused' || normalized === 'degraded' || normalized === 'warning') {
      return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
    }
    if (normalized === 'restarting' || normalized === 'starting') {
      return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
    }

    return 'bg-gray-500/20 text-gray-400 border-gray-500/30';
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStatusColor(
        status
      )} ${className}`}
    >
      {status}
    </span>
  );
}
